import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ketqua',
  templateUrl: './ketqua.component.html',
  styleUrls: ['./ketqua.component.scss']
})
export class KetquaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
